import { Popover } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import CheckIcon from '../../../assets/svg/CheckIcon';
import CrossIcon from '../../../assets/svg/CrossIcon';
import { CALL_OUTCOME_OPTIONS } from '../../../constants';

export const CallOutcomeFilter = ({ callOutcome, onChangeCallOutcome }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onChange = nextCallOutcome => {
    onChangeCallOutcome(prev => {
      return {
        ...prev,
        callOutcome: nextCallOutcome,
      };
    });
    onClosePopover();
  };

  const reset = () => {
    onChangeCallOutcome(prev => {
      return {
        ...prev,
        callOutcome: null,
      };
    });
  };

  const onOpenPopover = e => {
    if (e.target.localName !== 'button') return;
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const selectedCallOutcome = CALL_OUTCOME_OPTIONS.find(
    ({ value }) => value === callOutcome,
  );
  const hasCallOutcome = !!selectedCallOutcome;

  return (
    <>
      <button
        className={twMerge(
          'flex items-center justify-between gap-2 rounded-full py-[11px] px-6 text-brand-900 border border-brand-900 font-medium text-[16px]/[24px] focus-visible:outline-none',
          hasCallOutcome && 'bg-brand-900 text-white',
        )}
        onClick={onOpenPopover}
      >
        {hasCallOutcome ? selectedCallOutcome.label : 'Call Outcome'}
        {hasCallOutcome && (
          <div onClick={reset}>
            <CrossIcon className="w-4 h-4 text-white" />
          </div>
        )}
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-xl mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-60',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className="p-1 flex flex-col gap-1">
          {CALL_OUTCOME_OPTIONS.map(({ label, value }) => {
            const isSelected = value === selectedCallOutcome?.value;

            return (
              <div
                key={value}
                className="py-2 px-3 cursor-pointer flex items-center justify-between gap-1 rounded-lg hover:bg-brand-300/[0.08]"
                onClick={() => {
                  onChange(value);
                }}
              >
                <span className="text-[16px]/[24px] text-base-1000 truncate">
                  {label}
                </span>
                {isSelected && (
                  <CheckIcon className="w-4 h-4 text-brand-500 shrink-0" />
                )}
              </div>
            );
          })}
        </div>
      </Popover>
    </>
  );
};
